module.exports = __webpack_public_path__ + "static/saloon-c15af09ca0af3e329c1db26c38c9edec.svg";